import { render } from "./WhyUs.vue?vue&type=template&id=1dae97c4&scoped=true"
import script from "./WhyUs.vue?vue&type=script&lang=js"
export * from "./WhyUs.vue?vue&type=script&lang=js"

import "./WhyUs.vue?vue&type=style&index=0&id=1dae97c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dae97c4"]])

export default __exports__